import Pagination from '../Pagination'
import Sort from '../SortReq'

export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    businessUnit: other.businessUnit || null,
    buIds: other.buIds || null,
    orgIds: other.orgIds || null,
    type: other.type || null,
    account: other.account || null,
    status: other.status || null,
    realType: other.realType || null,
    approved: other.approved || null,
    userIds: other.userIds || [],
    action: other.action || null,
    maxAmount: other.maxAmount || null,
    minAmount: other.minAmount || null,
    // Booleans must survive an explicit false (e.g. the retention drill's isFtd:false)
    isFtd: other.isFtd == null ? null : other.isFtd,
    isStd: other.isStd == null ? null : other.isStd,
    isTest: other.isTest == null ? null : other.isTest,
    financeStatus: other.financeStatus || null,
    statusUserIds: other.statusUserIds || null,
    clientEmail: other.clientEmail || null,
    // registrationTime: other.registrationTime || {start: null, end: null},
    affiliateId: other.affiliateId || [],
    registrationTime: other.registrationTime || { start: null, end: null },
    //Search
    search: other.search || '',
    clientDetails: other.clientDetails || {},
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  }
}
